import React from "react";
import moment from 'moment';
import * as cocoSsd from "@tensorflow-models/coco-ssd";
import "@tensorflow/tfjs";
import "./styles.css";
import { UploadFile, UploadFileToAws, uploadTOS3BucketUrl } from "../../services/QualificationService";
import axios from "axios";
import { AWS_File_URL } from "../../utils/Constants";

class ObjectDetection extends React.Component {
  videoRef = React.createRef();
  canvasRef = React.createRef();
  lastCaptureTime = 0;
  ranvar = 0;
  detectionInterval = null; // Add this to track the interval
  model = null; // Store the model reference
  lastPhotoWarningObj = {
    'person' : 0,
    'absent' : 0,
    'phone' : 0
  }
  constructor(props) {
    super(props);
    this.state = {
      'person':  this.props.cameraObj?.person || 0,
      "phone":  this.props.cameraObj?.phone || 0,
      "absent":  this.props.cameraObj?.absent || 0,
      resetCount: 0,
    };
  }
  componentDidMount() {
    if (this.props.data && this.props.data.camera) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const webCamPromise = navigator.mediaDevices
          .getUserMedia({
            audio: false,
            video: {
              facingMode: "user",
              width: { ideal: 320 },
              height: { ideal: 240 }
            },
          })
          .then((stream) => {
            window.stream = stream;
            this.videoRef.current.srcObject = stream;
            return new Promise((resolve, reject) => {
              this.videoRef.current.onloadedmetadata = () => {
                resolve();
              };
            });
          })

        //loading the model only once for better performance
        const modelPromise = cocoSsd.load();

          webCamPromise.then(() => {
            this.videoRef.current.addEventListener('loadeddata', (e) => {
              if (this.videoRef.current === null) {
                return false
              }
              const runDetection = () => {
                Promise.all([modelPromise, webCamPromise])
                  .then((values) => {
                    this.model = values[0]; // Store model reference
                    this.startDetectionLoop(); // Start the detection loop
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              };
              runDetection();
            });
          })
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Check if the camera dependency has changed
    if (prevProps.hasCamera !== this.props.hasCamera) {
      if (this.props.data && this.props.data.camera) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            audio: false,
            video: {
              facingMode: "user",
            },
          })
          .then((stream) => {
            window.stream = stream;
            if(this.videoRef.current){
              this.videoRef.current.srcObject = stream;
            }
            return new Promise((resolve, reject) => {
              this.videoRef.current.onloadedmetadata = () => {
                resolve();
              };
            });
          })
          .then(() => {
            this.videoRef.current.addEventListener('loadeddata', (e) => {
              if (this.videoRef.current === null) {
                return false
              }

              //using already loaded model
              this.startDetectionLoop();
            });
          })
      }
    }
    }
  }

  // New method to start detection loop with setInterval
  startDetectionLoop = () => {
    if (this.detectionInterval) {
      clearInterval(this.detectionInterval);
    }
    
    this.detectionInterval = setInterval(async() => {
      if (!this.videoRef.current || !this.model) return;
      if (this.isDetecting) return; // skip if still busy
      this.isDetecting = true;
      try {
        await this.detectFrame(this.videoRef.current, this.model);
      } finally {
        this.isDetecting = false;
      }
    }, 1000); // Run detection every 1 second (adjust as needed)
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetCount != state.resetCount) {
      state.resetCount = props.resetCount
      state.person = 0
      state.phone = 0
      state.absent = 0
      props.setCameraObj({phone : 0,person : 0,absent : 0})
    }
    return null
  }

  componentWillUnmount() {
    // Clear the interval when component unmounts
    if (this.detectionInterval) {
      clearInterval(this.detectionInterval);
    }
    
    const stream = this.videoRef.current?.srcObject;
    const tracks = stream && stream.getTracks();

    tracks && tracks.forEach(function (track) {
      track.stop();
    });
    // this.videoRef.current.srcObject = window.stream;
    // Clear the video source
    if (this.videoRef.current) {
      this.videoRef.current.srcObject = null;
    }
    // Clear the model reference
    this.model = null;

    // Clear window stream reference
    if (window.stream) {
      window.stream = null;
    }
  }

  detectFrame = (video, model) => {
    const stream = this.videoRef.current.srcObject;
    let currentTime = new Date().getTime();
    if (stream && stream.active && video.videoWidth > 0 && video.videoHeight > 0) {
      model.detect(video).then((predictions) => {
        if (predictions.length > 0) {          
          if (predictions.length == 1) {
            if (predictions[0].class == 'cell phone' && currentTime - this.lastPhotoWarningObj?.phone > 30000) {
              this.setState({ phone: this.state.phone += 1 })
              this.capturePhoto('phone')
              this.lastPhotoWarningObj = {...this.lastPhotoWarningObj , phone : currentTime}
            }
          }
          else {
            let tempperson = 0
            predictions.map(i => {
              if (i.class == 'person') {
                tempperson += 1
              }
              if (i.class == 'cell phone' && currentTime - this.lastPhotoWarningObj?.phone > 30000) {
                this.setState({ phone: this.state.phone += 1 })
                this.props.setCameraObj({...this.props.cameraObj,phone : this.state.phone + 1})
                this.capturePhoto('phone')
                this.lastPhotoWarningObj = {...this.lastPhotoWarningObj , phone : currentTime}
              }
            })
            if (tempperson > 1 && currentTime - this.lastPhotoWarningObj?.person > 30000) { 
              this.setState({ person: this.state.person += 1 })
              this.props.setCameraObj({...this.props.cameraObj,person : this.state.person + 1})
              this.capturePhoto('person')
              this.lastPhotoWarningObj = {...this.lastPhotoWarningObj , person : currentTime}
              tempperson = 0
            }
          }
        }
        else if(currentTime - this.lastPhotoWarningObj?.absent > 30000){
          console.log("Student absent detected - tab minimized or not", document.hidden);
          this.setState({ absent: this.state.absent += 1 })
          this.props.setCameraObj({...this.props.cameraObj,absent : this.state.absent + 1})
          this.capturePhoto('absent')
          this.lastPhotoWarningObj = {...this.lastPhotoWarningObj , absent : currentTime}
        }
        // this.renderPredictions(predictions);
      });
    }
    // Removed requestAnimationFrame - now using setInterval
  };

  // Rest of your methods remain the same...
  renderPredictions = (predictions) => {
    const ctx = this.canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    // Font options.
    const font = "16px sans-serif";
    ctx.font = font;
    ctx.textBaseline = "top";
    predictions.forEach((prediction) => {
      const x = prediction.bbox[0];
      const y = prediction.bbox[1];
      const width = prediction.bbox[2];
      const height = prediction.bbox[3];
      // Draw the bounding box.
      ctx.strokeStyle = "#00FFFF";
      ctx.lineWidth = 4;
      ctx.strokeRect(x, y, width, height);
      // Draw the label background.
      ctx.fillStyle = "#00FFFF";
      const textWidth = ctx.measureText(prediction.class).width;
      const textHeight = parseInt(font, 10); // base 10
      ctx.fillRect(x, y, textWidth + 4, textHeight + 4);
    });

    predictions.forEach((prediction) => {
      const x = prediction.bbox[0];
      const y = prediction.bbox[1];
      // Draw the text last to ensure it's on top.
      ctx.fillStyle = "#000000";
      ctx.fillText(prediction.class, x, y);
    });
  };

  

  capturePhoto = async (warning_type) => {
    const currentTime = new Date().getTime();
    if (!this.props.data.launched) {
      return;
    }
    // Only allow one photo per 30 seconds
    try {
        // Create canvas and capture the image
        const canvas = document.createElement('canvas');
        canvas.width = this.videoRef.current.videoWidth;
        canvas.height = this.videoRef.current.videoHeight;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(this.videoRef.current, 0, 0, canvas.width, canvas.height);
        
        // Convert canvas to blob
        const photoBlob = await new Promise(resolve => {
            canvas.toBlob(resolve, 'image/jpeg', 0.9);
        });

        const user = localStorage.getItem("user");
        const userData = JSON.parse(user);

        const fileName = `captured-photo-${new Date().toISOString()}.jpeg`

        const randomString = Math.random().toString(36).slice(2, 7);
        const formData = new FormData();
        const path =`Students/${userData?.id}_${userData?.student_crm_id}_${userData?.first_name}_${userData?.last_name}/${this.props.data?.id}_${this.props.data?.name}/Exam Warning/${this.props.data?.name}_${userData?.student_crm_id}_${Date.now()}_${randomString}.${fileName?.split(".").pop()}`;
        const fileDetails = [{
          file_name: path,
          file_type: photoBlob.type,
        }]
        formData.append("uploadFiles", JSON.stringify(fileDetails));

        const res = await uploadTOS3BucketUrl(formData);

        const uploadURL = res?.data?.data[0]?.uploadURL
        const fileKey = res?.data?.data[0]?.fileKey;



        const uploadFileResponse = await axios.put(uploadURL, photoBlob, {
          headers: {
            "Content-Type": photoBlob.type,
          },
        });
        const fileSize = uploadFileResponse?.config?.data?.size

        let payload = {
          assignment : this.props.data.id,
          path : fileKey,
          attempt_no : Number(this.props.data.totalattempt || 0) + 1,
          size : fileSize,
          warning : warning_type == "person" ? `Second person detected: ${this.state.person}` : warning_type == 'phone' ? `Cell Phone detected: ${this.state.phone}` : `Student is absent: ${this.state.absent}`,
          timestamp : currentTime
        }
        const uplo = await UploadFileToAws(payload)

    //     let blob = axios({url : AWS_File_URL + fileKey,method: "GET",
    // responseType: "blob"})
    //     const url = window.URL.createObjectURL(new Blob([blob.data]));
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", fileName); 
    //   document.body.appendChild(link);
    //   link.click();
        

        // formData.append('assessment_id',this.props.data.id)
        // formData.append('file', photoBlob, `captured-photo-${new Date().toISOString()}.jpeg`);
        // formData.append('warning',warning_type == "person" ? `Second person detected: ${this.state.person}` : warning_type == 'phone' ? `Cell Phone detected: ${this.state.phone}` : `Student is absent: ${this.state.absent}`) 
        // formData.append('timestamp',currentTime)
        
        // // Upload to API
        // UploadFile(formData)
        //   .then((resp) => {
        //     console.log(resp.data)
        //   }).catch((err) => {
        //     console.log("Assignment.js error:", err)
        //   })
        
        console.log('Photo uploaded successfully');
    } catch (error) {
        // Basic error logging
        console.error('Error capturing or uploading photo:', error);
    }
  };

  render() {
    console.log("this.videoRef",this.videoRef)
    return (
      <div className="assessment-warning-logs">
        <video
          className="size"
          autoPlay
          playsInline
          muted
          // preload="none"
          preload="metadata" 
          ref={this.videoRef}
          width={(this.props.videoWidth && this.props.videoWidth == 'No') ? 0 : 100}
          height={(this.props.videoHeight && this.props.videoHeight == 'No') ? 0 : 100}
        />
        <canvas
          className="size d-none"
          ref={this.canvasRef}
          width="600"
          height="500"
        />

        <div className="assessment-warning-blk">
          <h2>Warning Log</h2>
          {/* {(this.state.person > 0 || this.state.phone > 0 || this.state.absent > 0) && */}
          <ul>
            {(this.props.data && this.props.data.camera) ?
              <>
                {this.state.person > 0 &&
                  <li>
                    <article>
                      <figure>
                        <i className="fal fa-user-friends"></i>
                      </figure>
                      <figcaption>
                        <p>{moment(new Date()).format("D MMMM YYYY HH:mm")}</p>
                        <h4>
                          Warning: <span>Second person detected: {this.state.person}</span>
                        </h4>
                      </figcaption>
                    </article>
                  </li>
                }
                {this.state.phone > 0 &&
                  <li>
                    <article>
                      <figure>
                        <i className="fal fa-mobile-alt"></i>
                      </figure>
                      <figcaption>
                        <p>{moment(new Date()).format("D MMMM YYYY HH:mm")}</p>
                        <h4>
                          Warning: <span>Cell Phone detected: {this.state.phone}</span>
                        </h4>
                      </figcaption>
                    </article>
                  </li>
                }
                {this.state.absent > 0 &&
                  <li>
                    <article>
                      <figure>
                        <i className="fal fa-chair-office"></i>
                      </figure>
                      <figcaption>
                        <p>{moment(new Date()).format("D MMMM YYYY HH:mm")}</p>
                        <h4>
                          Warning: <span>Student is absent: {this.state.absent}</span>
                        </h4>
                      </figcaption>
                    </article>
                  </li>
                }
              </>
              : null
            }
            {this.props.soundCount > 0 &&
              <li>
                <article>
                  <figure>
                    <i className="fal fa-microphone"></i>
                  </figure>
                  <figcaption>
                    <p>{moment(new Date()).format("D MMMM YYYY HH:mm")}</p>
                    <h4>
                      Warning: <span>Noise detected: {this.props.soundCount}</span>
                    </h4>
                  </figcaption>
                </article>
              </li>
            }            
            {this.props.switchAway > 0 &&
              <li>
                <article>
                  <figure>
                    <i className="fal fa-window"></i>
                  </figure>
                  <figcaption>
                    <p>{moment(new Date()).format("D MMMM YYYY HH:mm")}</p>
                    <h4>
                      Warning: <span>Browser tab changed during assessment: {this.props.switchAway}</span>
                    </h4>
                  </figcaption>
                </article>
              </li>
            }       
          </ul>
          {/* } */}
        </div>
      </div>
    );
  }
}

export default ObjectDetection;
